
import Component from '../../../assets/scripts/modules/component'

class QuizComponent extends Component {
  init () {
    this.slides = [...this.element.querySelectorAll('.quiz__slide')]
    this.title = this.element.querySelector('.quiz__title')
    this.counter = this.element.querySelector('.quiz__counter')

    if (!this.slides.length) {
      return
    }

    this.slides.forEach(slide => this.initSlide(slide))
    this.nextSlide()
  }

  getSlides () {
    if (!this.slides.length) {
      return
    }

    const currentSlide = this.slides.find(slide => slide.classList.contains('quiz__slide--active'))
    const currentSlideIndex = this.slides.findIndex(slide => slide === currentSlide)
    const nextSlide = this.slides[currentSlideIndex + 1]

    return [currentSlide, nextSlide, currentSlideIndex]
  }

  initSlide (slide) {
    if (!slide) {
      return
    }

    const navigationContainer = slide.querySelector('.quiz__slide-navigation')
    const responseContainer = slide.querySelector('.quiz__slide-responses')

    if (!navigationContainer || !responseContainer) {
      return
    }

    const nextButtons = [...navigationContainer.querySelectorAll('.button--next')]
    const restartButton = navigationContainer.querySelector('.button--restart')
    const responseButtons = [...responseContainer.querySelectorAll('.button, .link')]

    nextButtons.forEach(button => button.addEventListener('click', () => {
      this.nextSlide()
      navigationContainer.classList.remove('quiz__slide-navigation--visible')
    }))

    responseButtons.forEach((button, index) => button.addEventListener('click', event => {
      this.answerButtonClick(event, button, index)
      responseContainer.classList.remove('quiz__slide-responses--visible')
      responseContainer.classList.add('quiz__slide-responses--inactive')
    }))

    if (restartButton) {
      restartButton.addEventListener('click', () => window.location.reload())
    }

    this.scrollToEnd(true)
  }

  nextSlide () {
    const [currentSlide, nextSlide, currentSlideIndex] = this.getSlides()

    if (!nextSlide) {
      return
    }

    if (nextSlide.classList.contains('quiz__slide--looping')) {
      this.cloneSlide(nextSlide)
    }

    if (currentSlide) {
      currentSlide.classList.remove('quiz__slide--active')
    }

    nextSlide.classList.add('quiz__slide--visible')
    nextSlide.classList.add('quiz__slide--active')

    this.scrollToEnd()
    this.showSlideContents()
    this.updateCounter()
  }

  cloneSlide (slide) {
    if (!slide) {
      return
    }

    const clonedSlide = slide.cloneNode(true)

    slide.parentNode.appendChild(clonedSlide)
    this.initSlide(clonedSlide)

    // Reset slides reference
    this.slides = [...this.element.querySelectorAll('.quiz__slide')]
  }

  showSlideContents () {
    const [currentSlide, nextSlide, currentSlideIndex] = this.getSlides()

    if (!currentSlide) {
      return
    }

    const messages = [...currentSlide.querySelectorAll('.quiz__slide-messages .message')]
    const responseContainer = currentSlide.querySelector('.quiz__slide-responses')

    if (currentSlide.classList.contains('quiz__slide--type-score')) {
      this.updateScoreMessages(messages)
    }

    if (messages.length && responseContainer) {
      this.showMessages(messages, responseContainer)
    }
  }

  showMessages (messages, responseContainer, initialDelay = 750) {
    let delay = initialDelay

    window.setTimeout(() => this.hideTitle(), initialDelay + 3000)

    messages.forEach((message, index) => {
      window.setTimeout(() => {
        message.classList.remove('message--loading')
        message.classList.add('message--visible')

        this.scrollToEnd()
      }, delay)

      let messageDelay = 1000 + (message.innerText.trim().length * 15)
      const multiplier = parseInt(message.getAttribute('data-timeout-multiplier') || 1)

      messageDelay *= multiplier
      delay += messageDelay
    })

    window.setTimeout(() => {
      const [currentSlide, nextSlide, currentSlideIndex] = this.getSlides()
      const navigationContainer = currentSlide.querySelector('.quiz__slide-navigation')

      if (responseContainer && responseContainer.querySelectorAll('.button, .link').length) {
        responseContainer.classList.add('quiz__slide-responses--visible')
      } else if (currentSlide.classList.contains('quiz__slide--looping')) {
        this.nextSlide()
      } else if (navigationContainer) {
        navigationContainer.classList.add('quiz__slide-navigation--visible')
      }

      this.scrollToEnd()
    }, delay)

    this.scrollToEnd()
  }

  answerButtonClick (event, button, index) {
    const [currentSlide, nextSlide, currentSlideIndex] = this.getSlides()

    if (!currentSlide) {
      return
    }

    const container = [...currentSlide.querySelectorAll('.quiz__slide-answers')][index]

    if (!container) {
      return
    }

    [...button.parentNode.querySelectorAll('.button, .link')].forEach(button => {
      button.disabled = true
    })

    if (button.classList.contains('link')) {
      button.classList.add('link--selected')
    } else {
      button.classList.add('button--selected')
    }

    const answers = [...container.querySelectorAll('.message')]

    if (answers.length) {
      this.showMessages(answers, null, 0)
    }

    this.updateCounter()
  }

  hideTitle () {
    if (!this.title) {
      return
    }

    this.title.classList.add('quiz__title--hidden')
  }

  updateCounter () {
    if (!this.counter) {
      return
    }

    const [currentSlide, nextSlide, currentSlideIndex] = this.getSlides()

    let counterText = (this.counter && this.counter.getAttribute('data-text')) ? this.counter.getAttribute('data-text') : '$i / $j'
    counterText = counterText.replace('$i', currentSlideIndex + 1)
    counterText = counterText.replace('$j', this.slides.length)

    this.counter.innerText = counterText
    this.counter.classList.remove('quiz__counter--hidden')
  }

  updateScoreMessages (messages = []) {
    messages.forEach(message => {
      const textElement = message.querySelector('.message__text')

      if (textElement.innerText.indexOf('$i') === -1 && textElement.innerText.indexOf('$j') === -1) {
        return
      }

      const totalAnswerCount = [...this.element.querySelectorAll('.quiz__slide-responses .button--selected')]
      const totalCorrectCount = totalAnswerCount.filter(answer => answer.classList.contains('button--correct'))

      let messageText = textElement.innerText

      messageText = messageText.replace('$i', totalCorrectCount.length)
      messageText = messageText.replace('$j', totalAnswerCount.length)

      textElement.innerText = messageText.trim()
    })
  }

  scrollToEnd (instant = false) {
    window.requestAnimationFrame(() => window.scroll({ top: document.documentElement.offsetHeight, behavior: instant ? 'auto' : 'smooth' }))
  }
}

window.addEventListener('init-load', () => {
  for (const element of document.querySelectorAll('.quiz')) {
    element.instance = element.instance || new QuizComponent(element)
  }
})
